import { useQuery } from '@tanstack/react-query';
import { useEnv } from '../../../context/env-context';
import { useHandlers, useSite } from '../../../context/page-context';
import { supportsMetafields } from '../constants';
import type { MetafieldGroup } from '../types';

export const METAFIELD_QUERY_KEY = 'get-metafield-configuration';

export function useMetafieldConfiguration() {
  const { apis } = useHandlers();
  const site = useSite();
  const env = useEnv();

  return useQuery<MetafieldGroup[]>({
    queryKey: [METAFIELD_QUERY_KEY, site.siteId, site.siteEnv],
    queryFn: () => apis.platform.metafieldConfiguration(site.siteId, site.siteEnv),
    enabled: supportsMetafields(env.connected_platform),
  });
}
